import React, { useContext } from "react";
import { FormattedNumber } from "react-intl";
import IOrder_ItemUI from "../../../models/IOrder_ItemUI";
import SupplierContext from "../../../contexts/SupplierContext";
import OwLabel from "../OwLabel/OwLabel";
import OrderEntryService from "../../../services/OrderEntryService";
import IOrder_Item from "../../../models/IOrder_Item";

type Props = {
    item: IOrder_ItemUI | IOrder_Item;
    className?: string;
};

export const QtyDetail = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    if (props.item.uom_set_id) {
        // const uomSetQtyConversion = OrderService.getUomSetQty(
        //     props.item.qty || 1,
        //     props.item.Catalog_Item?.Base_Unit,
        //     props.item.Selected_Unit
        // );
        const uomSetQtyConversion = props.item.qty;

        let showUomSetConversion = false;

        if (uomSetQtyConversion) {
            showUomSetConversion = true;

            if (!supplierModel.hide_uom_base_qty) {
                showUomSetConversion = false;
            }

            if (supplierModel.allow_manual_uom_base_qty) {
                showUomSetConversion = false;
            }
        }

        return (
            <div className={props.className}>
                <div>
                    <FormattedNumber value={Number(props.item.uom_set_qty)} minimumFractionDigits={supplierModel.qty_precision} />
                </div>
                {showUomSetConversion ? (
                    <div className={"text-small mb-2"}>
                        {uomSetQtyConversion} {props.item.Catalog_Item?.Base_Unit?.unit_abbr}
                    </div>
                ) : null}
            </div>
        );
    } else {
        return <FormattedNumber value={Number(props.item.qty)} minimumFractionDigits={supplierModel.qty_precision} />;
    }
};
